import { render } from "./Parc.vue?vue&type=template&id=6beb4a90&scoped=true"
import script from "./Parc.vue?vue&type=script&lang=js"
export * from "./Parc.vue?vue&type=script&lang=js"

import "./Parc.vue?vue&type=style&index=0&id=6beb4a90&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6beb4a90"]])

export default __exports__